import React from 'react';
import { Link } from 'react-router-dom';
const Project = ({ project }) => {
    const { id, name, img, mobileImg, technology, link, githubClient, githubServer, github, description } = project;

    return (
        <div data-aos="zoom-in" className='my-10 p-5 rounded-xl shadow-2xl relative'>
            <div className="hero rounded-xl md:h-64 bg-top hover:bg-bottom ease-in-out duration-1000" style={{ backgroundImage: `url(${img})` }}>
            </div>
            <div className='flex flex-col justify-center items-center'>
                <img src={mobileImg} className='sm:block md:hidden h-32 w-full' alt="" />
                <h1 className="mb-5 sm:text-xl md:text-5xl font-bold text-center p-3">{name}</h1>
                <p>{technology.split(' ').map((t,index) => <button key={index} className='btn btn-primary btn-xs m-2'>{t}</button>)}</p>
                <ul className='mb-5 p-3'>{description.split('.').slice(0, 3).map((d, index) => <li key={index} className='list-item list-disc'>{d}</li>)}</ul>
                <div className='flex flex-col md:flex-row justify-between items-center md:absolute bottom-0'>
                    <a className='btn btn-success btn-sm ml-2 my-2' href={link} target="_blank" rel='noreferrer'>Live site</a>
                    {github && <a className='btn btn-success btn-sm ml-2 my-2' href={github} target="_blank" rel='noreferrer'>Github</a>}
                    {githubClient && <a className='btn btn-success btn-sm ml-2 my-2' href={githubClient} target="_blank" rel='noreferrer'>Github client</a>}
                    {githubServer && <a className='btn btn-success btn-sm ml-2 my-2' href={githubServer} target="_blank" rel='noreferrer'>Github server</a>}
                    <Link to={`project/${id}`} className='btn btn-sm btn-info ml-2'>View Details</Link>
                </div>
            </div>
        </div>
    );
};

export default Project;